import React from 'react';
import './assests/MenuBurger.css';
const MenuBurgerIcon = () => {
  return (<>
   <input type="checkbox" role="button" aria-label="Display the menu" class="menu "/>
  </>
  )
}

export default MenuBurgerIcon